import React from 'react';
export default function CircleFedora() {
  return (
<><ellipse cx="17.539" cy="5.72" rx="13.69" ry="4.33" transform="matrix(.99874 .05027 -.05558 .99845 0 0)" fill="#483737"/><path d="M10.173 1.61L8.626 5.662s2.783 1.83 8.109 2.254c5.326.425 9.586-1.389 9.586-1.389l-1.168-4.655z" fill="#6c5353"/><ellipse transform="matrix(.9995 .03138 -.0889 .99604 0 0)" ry="1.489" rx="7.527" cy="1.171" cx="17.793" fill="#483737"/></>); }
